'use es6';

import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Map as ImmutableMap } from 'immutable';
import { Alert } from 'foundations-components/transitional/components/Alert';
import DeprecationMessage from './DeprecationMessage';
import { hasDismissedBanner, permanentlyDismissBanner } from './bannerHelpers';
import { SHOW_BANNER } from 'reporting-data/constants/deprecate/deprecationTypes';
import { useNormalizedReport } from './useNormalizedReport';
import { AsyncStatus } from 'reporting-data/asyncData/AsyncStatus';
import { jsx as _jsx } from "react/jsx-runtime";
const usePrepareNormalizedReport = ({
  report
}) => {
  const normalizedReportResult = useNormalizedReport({
    report
  });
  return useMemo(() => {
    return normalizedReportResult.status === AsyncStatus.SUCCEEDED ? normalizedReportResult.data : report;
  }, [normalizedReportResult, report]);
};
export function ReportDeprecationAlert({
  report
}) {
  var _deprecation$get;
  const normalizedReport = usePrepareNormalizedReport({
    report
  });
  const [shouldShowAlert, setShouldShowAlert] = useState(true);
  const deprecation = normalizedReport.get('deprecation', new ImmutableMap());
  const isDismissible = (_deprecation$get = deprecation.get('dismissible')) !== null && _deprecation$get !== void 0 ? _deprecation$get : true;
  if (!shouldShowAlert || deprecation.get('type') !== SHOW_BANNER || hasDismissedBanner(report)) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Alert, {
      type: "info",
      closeable: isDismissible,
      onClose: () => {
        setShouldShowAlert(false);
        permanentlyDismissBanner(report);
      },
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(DeprecationMessage, {
        message: deprecation.get('message')
      })
    })
  });
}
ReportDeprecationAlert.propTypes = {
  report: PropTypes.object.isRequired
};
export default ReportDeprecationAlert;